import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import ProfileScreen from './screens/ProfileScreen';
import OrderListScreen from './screens/admin/OrderListScreen';
import ProductListScreen from './screens/admin/ProductListScreen';
import ProductEditScreen from './screens/admin/ProductEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
import store from './store';
import { Provider } from 'react-redux';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import SalesForm from './screens/SaleForm';
import SupplysForm from './screens/supplyForm';
import PurchasesForm from './screens/PurchaseForm';
import HouseEditScreen from './screens/admin/HouseEditScreen'; // Import the HouseEditScreen
import HouseListScreen from './screens/admin/HouseListScreen';
import HouseScreen from './screens/HouseScreen';
import CompoundScreen from './screens/CompoundScreen';
import Apphouse from './screens/houses';
import Appcontact from './screens/contact';
import Appservices from './screens/services';
import ExpenseListScreen from './screens/admin/ExpenseListScreen';
import ExpenseEditScreen from './screens/admin/ExpenseEditScreen';
import NoteListScreen from './screens/admin/NoteListScreen';
import NoteEditScreen from './screens/admin/NoteEditScreen';
import CustomerEditScreen from './screens/admin/CustomerEditSreen';
import CustomerListScreen from './screens/admin/CustomerListScreen';
import SaleListScreen from './screens/admin/SalesListScreen';
import SaleScreen from './screens/SaleScreen';
import SaleStaffScreen from './screens/SaleStaffScreen';
import SupplierEditScreen from './screens/admin/SupplierEditScreen';
import SupplierListScreen from './screens/admin/SupplierListScreen';
import TransfersForm from './screens/TransferForm';
import OpeningStocksForm from './screens/OpeningStockForm';
import StocksForm from './screens/StockForm';
import ExpenseUserList from './screens/ExpenseUserList';
import ProductUserList from './screens/ProductUserList';
import CashUserList from './screens/CashUserList';
import CustomerUserList from './screens/CustomerUserList';
import SupplierUserList from './screens/SupplierUserList';
import SupplyListScreen from './screens/admin/SupplyListScreen';
import SupplyScreen from './screens/SupplyScreen';
import TransferListScreen from './screens/admin/TransferListScreen';
import TransferScreen from './screens/TransferScreen';
import StockScreen from './screens/StockScreen';
import DailyStockScreen from './screens/DailyStockScreen';
import OpeningStockScreen from './screens/OpeningStockScreen';
import StockListScreen from './screens/admin/StockListScreen';
import DailyStockListScreen from './screens/admin/DailyStockListScreen';
import OpeningStockListScreen from './screens/admin/OpeningStockListScreen';
import SalesEditScreen from './screens/SalesEditScreen';
import StocksEditScreen from './screens/StockEditScreen';
import OpeningStocksEditScreen from './screens/OpeningStockEditScreen';
import OpeningStoreStockEditScreen from './storeScreens/OpeningStoreStockEditScreen';
import TransferEditScreen from './screens/TransferEditScreen';
import TransferAddScreen from './screens/TransferAddScreen';
import CartForm from './screens/CartForm';
import StaffSale from './screens/StaffSale';
import StaffSupply from './screens/StaffSupply';
import StaffStock from './screens/StaffStock';
import StaffDailyStock from './screens/StaffDailyStock';
import StaffOpeningStock from './screens/StaffOpeningStock';
import StaffTransfer from './screens/StaffTransfer';
import StockAnalysis from './screens/admin/StockAnalysis';
import BalanceStaffScreen from './screens/admin/BalanceStaffScreen';
import BalanceByUserStaff from './screens/admin/BalanceByUserStaff';
import Balance from './screens/admin/Balance';
import BalanceByUser from './screens/admin/BalanceByUser';
import BalanceByCustomer from './screens/admin/BalanceByCustomer';
import BalanceByCustomerStaff from './screens/admin/BalanceByCustomerStaff';
import NetCash from './screens/admin/NetCash';
import NetCashEdit from './screens/admin/NetCashEdit';
import ExpenseScreen from './screens/ExpenseScreen';
import ExpenseStaffScreen from './screens/ExpenseStaffScreen';
import IncomeScreen from './screens/IncomeScreen';
import IncomeStafffScreen from './screens/IncomeStaffScreen';
import NoteScreen from './screens/NoteScreen';
import DepositScreen from './screens/DepositScreen';
import DepositEditScreen from './screens/admin/DepositEditScreen';
import DepositListScreen from './screens/admin/DepositListScreen';
import AllTotal from './screens/admin/AllTotal';
import BagScreen from './screens/BagScreen';
import BagEditScreen from './screens/admin/BagEditScreen';
import BagListScreen from './screens/admin/BagListScreen';
import StaffNote from './screens/StaffNote';
import StockReport from './screens/admin/StockReport';
import SupplysEditScreen from './screens/SupplyEditScreen';
import SupplyCopyScreen from './screens/SupplyCopyScreen';
import AdminForm from './screens/AdminForm';
import BankUserList from './screens/BankUserList';
import StaffHouseList from './screens/StaffHouseList';
import StaffHomeScreen from './screens/StaffHomeScreen';
import ProductStaffEditScreen from './screens/admin/ProductStaffEditScreen';
import ExpenseStaffEditScreen from './screens/admin/ExpenseStaffEditScreen';
import DepositStaffEditScreen from './screens/admin/DepositStaffEditScreen';
import BagStaffEditScreen from './screens/admin/BagStaffEditScreen';
import CustomerStaffEditScreen from './screens/admin/CustomerStaffEditScreen';
import SupplierStaffEditScreen from './screens/admin/SupplierStaffEditScreen';
import HouseStaffEditScreen from './screens/admin/HouseStaffEditScreen';
import AdminProfileScreen from './screens/admin/AdminProfileScreen.jsx';
import AdminUsersScreen from './screens/admin/AdminUsersScreen';
import UseStockAnalysis from './screens/admin/useStockAnalysis';
import NetUserEditScreen from './screens/admin/NetUserEditScreen';
import AddExpenseScreen from './screens/admin/AddExpenseScreen.jsx';
import AddIncomeScreen from './screens/admin/AddIncomeScreen.jsx';
import AddDepositScreen from './screens/admin/AddDepositScreen.jsx';
import AddStaffExpense from './screens/admin/AddStaffExpense.jsx';
import AddStaffDeposit from './screens/admin/AddStaffDeposit.jsx';
import AddStaffIncome from './screens/admin/AddStaffIncome.jsx';
import StockUniqueDates from './screens/admin/StockUniqueDates';
import WorkingCapital from './screens/admin/WorkingCapital';
import StockDateExpenses from './screens/admin/StockDateExpenses';
import ExpenseCategory from './screens/admin/ExpenseCategory';
import IncomeCategory from './screens/admin/IncomeCategory';
import ReportStockScreen from './screens/admin/ReportStockScreen.jsx';
import StartStockScreen from './screens/admin/StartStockScreen.jsx';
import SupplierBalanceScreen from './screens/admin/SupplierBalanceScreen.jsx';
import PurchaseListScreen from './screens/admin/PurchaseListScreen';
import AddNoteScreen from './screens/admin/AddNoteScreen.jsx';
import AddUserNote from './screens/admin/AddUserNote.jsx';
import DailyStocksForm from './screens/DailyStocksForm';
import DailyStocksEditScreen from './screens/DailyStocksEditScreen';
import DailyStockAnalysis from './screens/admin/DailyStockAnalysis';
import DailyStockReport from './screens/admin/DailyStockReport';
import DailyStockUniqueDates from './screens/admin/DailyStockUniqueDates';
import AddExpenseFromExcelScreen from './screens/admin/AddExpenseFromExcelScreen.jsx';
import AddProductsFromExcelScreen from './screens/admin/AddProductsFromExcelScreen.jsx';
import BulkProductUpdateWithImageUploadScreen from './screens/admin/BulkProductUpdateWithImageUploadScreen.jsx';
import BulkEditExpensesScreen from './screens/admin/BulkEditExpensesScreen.jsx';
import BulkIncomeUpdateWithImageUploadScreen from './screens/admin/BulkIncomeUpdateWithImageUploadScreen.jsx';
import AddIncomeFromExcelScreen from './screens/admin/AddIncomeFromExcelScreen.jsx';
import CreateMultipleProductScreen from './screens/admin/CreateMultipleProductScreen.jsx';
import BulkExpenseBatchUpdateScreen from './screens/admin/BulkExpenseBatchUpdateScreen.jsx';
import IncomeExpenseCategories from './screens/admin/IncomeExpenseCategories';
import ExpenseInvoices from './screens/admin/ExpenseInvoices';
import ExpenseInvoiceSummary from './screens/admin/ExpenseInvoiceSummary';
import SupplyInvoiceSummary from './screens/admin/SupplyInvoiceSummary';
import SupplySummary from './screens/admin/SupplySummary';
import StockBulkEditScreen from './screens/admin/StockBulkEditScreen';
import InsurancesEditScreen from './screens/insurancesEditScreen';
import InsuranceScreen from './screens/insuranceScreen.jsx';
import InsurancesForm from './screens/insurancesForm.js';
import InsuranceListScreen from './screens/admin/InsuranceListScreen';
import StaffInsurance from './screens/StaffInsurance.jsx';
import BillsEditScreen from './screens/BillsEditScreen.jsx';
import BillScreen from './screens/BillScreen.jsx';
import BillsForm from './screens/BillsForm.js';
import BillListScreen from './screens/admin/BillListScreen';
import StaffBill from './screens/StaffBill.jsx';
import CustomerImportScreen from './screens/admin/CustomerImportScreen.jsx';
import CustomerEditImportScreen from './screens/admin/CustomerEditImportScreen.jsx';
import SalesSearchReplaceScreen from './screens/admin/SalesSearchReplaceScreen.jsx';
import StocksSearchDeleteScreen from './screens/admin/StocksSearchDeleteScreen.jsx';
import SalesSearchDeleteScreen from './screens/admin/SalesSearchDeleteScreen.jsx';
import TransfersSearchDeleteScreen from './screens/admin/TransfersSearchDeleteScreen.jsx';
import DailyStocksSearchDeleteScreen from './screens/admin/DailyStocksSearchDeleteScreen.jsx';

import SaleNoteSearchReplaceScreen from './screens/admin/SaleNoteSearchReplaceScreen.jsx';
import SupplysSearchReplaceScreen from './screens/admin/SupplysSearchReplaceScreen.jsx';
import TransfersSearchReplaceScreen from './screens/admin/TransfersSearchReplaceScreen.jsx';
import StocksSearchReplaceScreen from './screens/admin/StocksSearchReplaceScreen.jsx';
import OpeningStockSearchReplaceScreen from './screens/admin/OpeningStockSearchReplaceScreen.jsx';
import OpeningStoreStockSearchReplaceScreen from './storeScreens/storeAdmin/OpeningStoreStockSearchReplaceScreen.jsx';
import StockNoteSearchReplaceScreen from './screens/admin/StockNoteSearchReplaceScreen.jsx';
import DailyStocksSearchReplaceScreen from './screens/admin/DailyStocksSearchReplaceScreen.jsx';
import DailyStockNoteSearchReplaceScreen from './screens/admin/DailyStockNoteSearchReplaceScreen.jsx';
import ExpenseSearchReplaceScreen from './screens/admin/ExpenseSearchReplaceScreen.jsx';
import AddStoreExpenseScreen from "./storeScreens/storeAdmin/AddStoreExpenseScreen";
import DailyStoreStockScreen from "./storeScreens/DailyStoreStockScreen";
import DailyStoreStocksEditScreen from "./storeScreens/DailyStoreStocksEditScreen";
import DailyStoreStocksForm from "./storeScreens/DailyStoreStocksForm";
import OpeningStoreStock from "./storeScreens/OpeningStoreStock";
import OpeningStoreStockBag from "./storeScreens/OpeningStoreStockBag";

import OpeningStoreStockForm from "./storeScreens/OpeningStoreStockForm";
import OpeningStoreStockScreen from "./storeScreens/OpeningStoreStockScreen";
import StaffDailyStoreStock from "./storeScreens/StaffDailyStoreStock";
import StaffOpeningStoreStock from "./storeScreens/StaffOpeningStoreStock";
import StaffStoreSale from "./storeScreens/StaffStoreSale";
import StaffStoreStock from "./storeScreens/StaffStoreStock";
import StaffStoreSupply from "./storeScreens/StaffStoreSupply";
import StaffStoreTransfer from "./storeScreens/StaffStoreTransfer";
import StoreAdminForm from "./storeScreens/StoreAdminForm";
import StoreBalance from "./storeScreens/StoreBalance";
import ConsolidatedBalance from "./storeScreens/storeAdmin/ConsolidatedBalance";
import ConsolidatedWorkingCapital from "./storeScreens/storeAdmin/ConsolidatedWorkingCapital";
import StoreBalanceByCustomer from "./storeScreens/StoreBalanceByCustomer";
import StoreBalanceByCustomerStaff from "./storeScreens/StoreBalanceByCustomerStaff";
import StoreBalanceByUser from "./storeScreens/StoreBalanceByUser";
import StoreBalanceByUserStaff from "./storeScreens/StoreBalanceByUserStaff";
import StoreBalanceStaffScreen from "./storeScreens/StoreBalanceStaffScreen";
import StoreBankUserList from "./storeScreens/StoreBankUserList";
import StoreCartForm from "./storeScreens/StoreCartForm";
import StoreCartScreen from "./storeScreens/StoreCartScreen";
import StoreCashUserList from "./storeScreens/StoreCashUserList";


import StoreDepositScreen from "./storeScreens/StoreDepositScreen";
import StoreDepositStaffEditScreen from "./storeScreens/StoreDepositStaffEditScreen";
import StoreExpenseCategory from "./storeScreens/StoreExpenseCategory";

import StoreExpenseInvoiceSummary from "./storeScreens/StoreExpenseInvoiceSummary";

import StoreExpenseScreen from "./storeScreens/StoreExpenseScreen";
import StoreExpenseStaffScreen from "./storeScreens/StoreExpenseStaffScreen";
import StoreExpenseUserList from "./storeScreens/StoreExpenseUserList";
import StoreIncomeExpenseCategories from "./storeScreens/StoreIncomeExpenseCategories";
import StoreIncomeScreen from "./storeScreens/StoreIncomeScreen";
import StoreIncomeStaffScreen from "./storeScreens/StoreIncomeStaffScreen";
import StoreSaleForm from "./storeScreens/StoreSaleForm";
import StoreSaleScreen from "./storeScreens/StoreSaleScreen";
import StoreSalesEditScreen from "./storeScreens/StoreSalesEditScreen";
import StoreSalesAddScreen from "./storeScreens/StoreSalesAddScreen";
import StoreSaleStaffScreen from "./storeScreens/StoreSaleStaffScreen";
import StoreStockEditScreen from "./storeScreens/StoreStockEditScreen";
import StoreStockForm from "./storeScreens/StoreStockForm";
import StoreStockScreen from "./storeScreens/StoreStockScreen";
import StoreSupplyEditScreen from "./storeScreens/StoreSupplyEditScreen";
import StoreSupplyForm from "./storeScreens/StoreSupplyForm";
import StoreSupplyScreen from "./storeScreens/StoreSupplyScreen";
import StoreTransferEditScreen from "./storeScreens/StoreTransferEditScreen";
import StoreTransferAddScreen from "./storeScreens/StoreTransferAddScreen";
import StoreTransferForm from "./storeScreens/StoreTransferForm";
import StoreTransferScreen from "./storeScreens/StoreTransferScreen";
import StoreSaleListScreen from "./storeScreens/storeAdmin/StoreSalesListScreen";

import AddStoreExpenseFromExcelScreen from "./storeScreens/storeAdmin/AddStoreExpenseFromExcelScreen";
import AddStoreIncomeFromExcelScreen from "./storeScreens/storeAdmin/AddStoreIncomeFromExcelScreen";
import BulkEditStoreExpensesScreen from "./storeScreens/storeAdmin/BulkEditStoreExpensesScreen";
import BulkStoreIncomeUpdateWithImageUploadScreen from "./storeScreens/storeAdmin/BulkStoreIncomeUpdateWithImageUploadScreen";
import BulkStoreTransferBatchUpdateScreen from "./storeScreens/storeAdmin/BulkStoreTransferBatchUpdateScreen";
import DailyStoreStockAnalysis from "./storeScreens/storeAdmin/DailyStoreStockAnalysis";
import DailyStoreStockListScreen from "./storeScreens/storeAdmin/DailyStoreStockListScreen";
import DailyStoreStockReport from "./storeScreens/storeAdmin/DailyStoreStockReport";
import DailyStoreStockUniqueDates from "./storeScreens/storeAdmin/DailyStoreStockUniqueDates";
import OpeningStoreStockListScreen from "./storeScreens/storeAdmin/OpeningStoreStockListScreen";
import ReportStoreStockScreen from "./storeScreens/storeAdmin/ReportStoreStockScreen";
import StartStoreStockScreen from "./storeScreens/storeAdmin/StartStoreStockScreen";
import StockDateStoreExpenses from "./storeScreens/storeAdmin/StockDateStoreExpenses";
import StoreAllTotal from "./storeScreens/storeAdmin/StoreAllTotal";
import StoreDepositEditScreen from "./storeScreens/storeAdmin/StoreDepositEditScreen";
import StoreDepositListScreen from "./storeScreens/storeAdmin/StoreDepositListScreen";

import StoreExpenseCategories from "./storeScreens/storeAdmin/StoreExpenseCategories";

import StoreExpenseEditScreen from "./storeScreens/storeAdmin/StoreExpenseEditScreen";
import StoreExpenseInvoices from "./storeScreens/storeAdmin/StoreExpenseInvoices";
import StoreExpenseListScreen from "./storeScreens/storeAdmin/StoreExpenseListScreen";
import StoreExpenseSearchReplaceScreen from "./storeScreens/storeAdmin/StoreExpenseSearchReplaceScreen";
import StoreExpenseStaffEditScreen from "./storeScreens/storeAdmin/StoreExpenseStaffEditScreen";
import StoreIncomeCategory from "./storeScreens/storeAdmin/StoreIncomeCategory";
import StoreSalesSearchReplaceScreen from "./storeScreens/storeAdmin/StoreSalesSearchReplaceScreen";
import StoreStockAnalysis from "./storeScreens/storeAdmin/StoreStockAnalysis";
import StoreStockBulkEditScreen from "./storeScreens/storeAdmin/StoreStockBulkEditScreen";
import StoreStockListScreen from "./storeScreens/storeAdmin/StoreStockListScreen";
import StoreStockNoteSearchReplaceScreen from "./storeScreens/storeAdmin/StoreStockNoteSearchReplaceScreen";
import StoreStockReport from "./storeScreens/storeAdmin/StoreStockReport";
import StoreStocksSearchReplaceScreen from "./storeScreens/storeAdmin/StoreStocksSearchReplaceScreen";
import DailyStoreStocksSearchReplaceScreen from "./storeScreens/storeAdmin/DailyStoreStocksSearchReplaceScreen";
import DailyStoreStockNoteSearchReplaceScreen from "./storeScreens/storeAdmin/DailyStoreStockNoteSearchReplaceScreen";


import StoreStockUniqueDates from "./storeScreens/storeAdmin/StoreStockUniqueDates";
import StoreSupplyInvoiceSummary from "./storeScreens/storeAdmin/StoreSupplyInvoiceSummary";
import StoreSupplyListScreen from "./storeScreens/storeAdmin/StoreSupplyListScreen";
import StoreSupplysSearchReplaceScreen from "./storeScreens/storeAdmin/StoreSupplysSearchReplaceScreen";
import StoreSupplySummary from "./storeScreens/storeAdmin/StoreSupplySummary";
import StoreTransferListScreen from "./storeScreens/storeAdmin/StoreTransferListScreen";
import StoreTransfersSearchReplaceScreen from "./storeScreens/storeAdmin/StoreTransfersSearchReplaceScreen";
import StoreWorkingCapital from "./storeScreens/storeAdmin/StoreWorkingCapital";
import UseStoreStockAnalysis from "./storeScreens/storeAdmin/UseStoreStockAnalysis";
import NetStoreCash from "./storeScreens/storeAdmin/NetStoreCash";
import NetStoreCashEdit from "./storeScreens/storeAdmin/NetStoreCashEdit";
import AddStaffStoreDeposit from "./storeScreens/storeAdmin/AddStaffStoreDeposit";
import AddStaffStoreExpense from "./storeScreens/storeAdmin/AddStaffStoreExpense";
import AddStaffStoreIncome from "./storeScreens/storeAdmin/AddStaffStoreIncome";
import AddStoreDepositScreen from "./storeScreens/storeAdmin/AddStoreDepositScreen";
import AddStoreIncomeScreen from "./storeScreens/storeAdmin/AddStoreIncomeScreen";
import DailyStocksAddScreen from './screens/DailyStocksAddScreen';
import SalesAddScreen from './screens/SalesAddScreen';

import StocksAddScreen from './screens/StocksAddScreen';

import OtherExpenseScreen from "./screens/OtherExpenseScreen";
import OtherExpenseStaffScreen from "./screens/OtherExpenseStaffScreen";
import OtherExpenseUserList from "./screens/OtherExpenseUserList";
import AddOtherExpenseFromExcelScreen from "./screens/admin/AddOtherExpenseFromExcelScreen";
import AddOtherExpenseScreen from "./screens/admin/AddOtherExpenseScreen";
import AddStaffOtherExpense from "./screens/admin/AddStaffOtherExpense";
import OtherExpenseCategory from "./screens/admin/OtherExpenseCategory";
import OtherExpenseEditScreen from "./screens/admin/OtherExpenseEditScreen";
import OtherExpenseInvoices from "./screens/admin/OtherExpenseInvoices";
import OtherExpenseInvoiceSummary from "./screens/admin/OtherExpenseInvoiceSummary";
import OtherExpenseListScreen from "./screens/admin/OtherExpenseListScreen";
import OtherExpenseSearchReplaceScreen from "./screens/admin/OtherExpenseSearchReplaceScreen";
import BulkEditOtherExpensesScreen from "./screens/admin/BulkEditOtherExpensesScreen";
import BulkOtherExpenseBatchUpdateScreen from "./screens/admin/BulkOtherExpenseBatchUpdateScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      <Route index={true} path='/' element={<HomeScreen />} />
      <Route path='/search/:keyword' element={<HomeScreen />} />
      
      <Route path='/page/:pageNumber' element={<HomeScreen />} />
      <Route
        path='/search/:keyword/page/:pageNumber'
        element={<HomeScreen />}
      />
      
      <Route
        path='/house/CompoundScreen'
        element={<CompoundScreen />}
      />
      <Route
        path='/house/HomeScreen'
        element={<HomeScreen />}
      />
       <Route
        path='/houses'
        element={<Apphouse />}
      />
      <Route path='/house/:id' element={<HouseScreen />} />
      
      <Route path='/alltotal' element={<AllTotal />} />
      <Route
          path='/admin/house/:id/edit'
          element={<HouseEditScreen />}
        /> {/* New route for House Edit */}
        <Route
          path='/house/:id/edit'
          element={<HouseStaffEditScreen />}
        /> {/* New route for House Edit */}
      <Route path='/expense/:id' element={<ExpenseScreen />} />
      <Route path='/staffexpense/:id' element={<ExpenseStaffScreen />} />
      <Route path='/deposit/:id' element={<DepositScreen />} />
      <Route path='/income/:id' element={<IncomeScreen />} />
      <Route path='/staffincome/:id' element={<IncomeStafffScreen />} />
      <Route path='/note/:id' element={<NoteScreen />} />
      <Route path='/bag/:id' element={<BagScreen />} />
      <Route path='/product/:id' element={<ProductScreen />} />
      <Route path='/cart' element={<CartScreen />} />
      <Route path='/staffhomescreen' element={<StaffHomeScreen />} />
      <Route path='/cartform' element={<CartForm />} />

      <Route path='/otherExpense/:id' element={<OtherExpenseScreen />} />
      <Route path='/staffotherExpense/:id' element={<OtherExpenseStaffScreen />} />
      <Route path='/otherExpenselist' element={<OtherExpenseUserList />} />


      
      <Route path='/staffsale' element={< StaffSale />} />
      <Route path='/stockanalysis' element={< StockAnalysis />} />
      <Route path='/dailystockanalysis' element={< DailyStockAnalysis />} />
      <Route path='/dailystockreport' element={< DailyStockReport />} />
      <Route path='/stockuniquedates' element={< StockUniqueDates />} />
      <Route path='/dailystockuniquedates' element={< DailyStockUniqueDates />} />
      <Route path='/reportstockscreen' element={< ReportStockScreen />} />
      <Route path='/stockreport' element={< StockReport />} />

      <Route path='/balancescreen' element={< BalanceStaffScreen />} />
      <Route path='/balancebyuserscreen' element={< BalanceByUserStaff />} />
      <Route path='/balancebycustomerscreen' element={< BalanceByCustomerStaff />} />
      <Route path='/create/message' element={< AddUserNote />} />
      <Route path='/create/notification' element={< AddNoteScreen />} />
      <Route path='/stockdatexpenses' element={< StockDateExpenses />} />
      <Route path='/create/expense' element={< AddExpenseScreen />} />
      <Route path='/create/staff/expense' element={< AddStaffExpense />} />
      <Route path='/create/income' element={< AddIncomeScreen />} />
      <Route path='/create/staff/income' element={< AddStaffIncome />} />
      <Route path='/create/deposit' element={< AddDepositScreen />} />
      <Route path='/create/staff/deposit' element={< AddStaffDeposit />} />
      
      <Route path='/staffsupply' element={< StaffSupply />} />
      <Route path='/staffstock' element={< StaffStock />} />
      <Route path='/staffdailystock' element={< StaffDailyStock />} />
      <Route path='/staffnote' element={< StaffNote />} />
      <Route path='/itemsneeded' element={< UseStockAnalysis/>} />
      <Route path='/staffopeningstock' element={< StaffOpeningStock />} />
      <Route path='/stafftransfer' element={< StaffTransfer />} />
      <Route path='/customeruserlist' element={<CustomerUserList/>} />
      <Route path='/customer/:id/edit' element={<CustomerStaffEditScreen />} />
      <Route path='/supplier/:id/edit' element={<SupplierStaffEditScreen />} />
      <Route path='/supplierlist' element={<SupplierUserList />} />
      <Route path='/admin/note/:id/edit' element={< NoteEditScreen />} />
      <Route path='/admin/bag/:id/edit' element={< BagEditScreen />} />
      <Route path='/bag/:id/edit' element={< BagStaffEditScreen />} />
      <Route path='/contact' element={<Appcontact />} />
      <Route path='/services' element={<Appservices />} />
      <Route path='/login' element={<LoginScreen />} />
      <Route path='/register' element={<RegisterScreen />} />
      <Route path='/salesform' element={<SalesForm />} />
      <Route path='/supplysform' element={<SupplysForm />} />
      <Route path='/transfersform' element={<TransfersForm />} />
      <Route path='/purchasesform' element={<PurchasesForm />} />
      <Route path='/stocksform' element={<StocksForm />} />
      <Route path='/dailystocksform' element={<DailyStocksForm />} />
      <Route path='/expenselist' element={<ExpenseUserList />} />
      <Route path='/productlist' element={<ProductUserList />} />
      <Route path='/cashlist' element={<CashUserList />} />
      <Route path='/bankuserlist' element={<BankUserList />} />
      <Route path='/staffhouselist' element={<StaffHouseList />} />
      <Route path='/income/:id/edit' element={<NetUserEditScreen />} />
      <Route path='/admin/income/:id/edit' element={<NetCashEdit />} />
      <Route path='/expense/:id/edit' element={<ExpenseStaffEditScreen />} />
      <Route path='/admin/deposit/:id/edit' element={<DepositEditScreen />} />
      <Route path='/deposit/:id/edit' element={<DepositStaffEditScreen />} />
      <Route path='/supply/:id/edit' element={<SupplysEditScreen />} />
      <Route path='/supply/:id/copy' element={<SupplyCopyScreen />} />
      <Route path='/openingstocksform' element={<OpeningStocksForm />} />
      <Route path='' element={<PrivateRoute />}>
        <Route path='/shipping' element={<ShippingScreen />} />
        <Route path='/payment' element={<PaymentScreen />} />
        <Route path='/placeorder' element={<PlaceOrderScreen />} />
        <Route path='/order/:id' element={<OrderScreen />} />
        <Route path='/sale/:id' element={<SaleScreen />} />
        <Route path='/staffsale/:id' element={<SaleStaffScreen />} />
         <Route path='/create/expense' element={< AddExpenseScreen />} />
      <Route path='/create/product/excelform' element={< AddProductsFromExcelScreen />} />
      <Route path='/create/income/excelform' element={< AddIncomeFromExcelScreen />} />
      <Route path='/create/expense/excelform' element={< AddExpenseFromExcelScreen />} />
       <Route path='/create/multiproduct/excelform' element={< CreateMultipleProductScreen />} />

        <Route path='/stock/:id' element={< StockScreen/>} />
        <Route path='/dailyStock/:id' element={< DailyStockScreen/>} />
        <Route path='/openingstock/:id' element={< OpeningStockScreen />} />
        <Route path='/transfer/:id' element={<TransferScreen />} />
        <Route path='/supply/:id' element={<SupplyScreen />} />
        <Route path='/profile' element={<ProfileScreen />} />
        <Route path='/staffinsurance' element={< StaffInsurance />} />
        <Route path='/insurance/:id' element={<InsuranceScreen />} />
        <Route path='/insurancesform' element={<InsurancesForm />} />
        <Route path='/staffbill' element={< StaffBill />} />
        <Route path='/bill/:id' element={<BillScreen />} />
        <Route path='/billsform' element={<BillsForm />} />
        <Route path='/product/:id/edit' element={<ProductStaffEditScreen />} />

        <Route path='/storeExpense/:id' element={<StoreExpenseScreen />} />
<Route path='/staffstoreExpense/:id' element={<StoreExpenseStaffScreen />} />
<Route path='/storeDeposit/:id' element={<StoreDepositScreen />} />
<Route path='/storeIncome/:id' element={<StoreIncomeScreen />} />
<Route path='/staffstoreIncome/:id' element={<StoreIncomeStaffScreen />} />
<Route path='/storeCartform' element={<StoreCartForm />} />
<Route path='/staffstoreSale' element={<StaffStoreSale />} />
<Route path='/storeBalancescreen' element={<StoreBalanceStaffScreen />} />
<Route path='/storeBalancebyuserscreen' element={<StoreBalanceByUserStaff />} />
<Route path='/storeBalancebycustomerscreen' element={<StoreBalanceByCustomerStaff />} />
<Route path='/create/storeExpense' element={<AddStoreExpenseScreen />} />
<Route path='/create/staff/storeExpense' element={<AddStaffStoreExpense />} />
<Route path='/create/storeIncome' element={<AddStoreIncomeScreen />} />
<Route path='/create/staff/storeIncome' element={<AddStaffStoreIncome />} />
<Route path='/create/storeDeposit' element={<AddStoreDepositScreen />} />
<Route path='/create/staff/storeDeposit' element={<AddStaffStoreDeposit />} />
<Route path='/staffstoreSupply' element={<StaffStoreSupply />} />
<Route path='/staffstoreStock' element={<StaffStoreStock />} />
<Route path='/staffdailystoreStock' element={<StaffDailyStoreStock />} />
<Route path='/staffopeningstoreStock' element={<StaffOpeningStoreStock />} />
<Route path='/staffstoreTransfer' element={<StaffStoreTransfer />} />
<Route path='/storeSalesform' element={<StoreSaleForm />} />
<Route path='/storeStockform' element={<StoreStockForm />} />
<Route path='/dailystoreStocksform' element={<DailyStoreStocksForm />} />
<Route path='/storeExpenselist' element={<StoreExpenseUserList />} />
<Route path='/storeExpense/:id/edit' element={<StoreExpenseStaffEditScreen />} />
<Route path='/storeAdmin/storeDeposit/:id/edit' element={<StoreDepositEditScreen />} />
<Route path='/storeDeposit/:id/edit' element={<StoreDepositStaffEditScreen />} />
<Route path='/openingstoreStocksform' element={<OpeningStoreStockForm />} />
<Route path='/storeSale/:id' element={<StoreSaleScreen />} />
<Route path='/staffstoreSale/:id' element={<StoreSaleStaffScreen />} />
<Route path='/storeStock/:id' element={<StoreStockScreen />} />
<Route path='/dailyStoreStock/:id' element={<DailyStoreStockScreen />} />
<Route path='/openingstoreStock/:id' element={<OpeningStoreStockScreen />} />
<Route path='/storeTransfer/:id' element={<StoreTransferScreen />} />
<Route path='/storeSupply/:id' element={<StoreSupplyScreen />} />
<Route path='/DailyStoreStocksEditScreen/:id' element={<DailyStoreStocksEditScreen />} />
<Route path='/OpeningStoreStock' element={<OpeningStoreStock />} />
<Route path='/OpeningStoreStockBag' element={<OpeningStoreStockBag />} />
<Route path='/storeAdmin/useStoreStockAnalysis' element={< UseStoreStockAnalysis />} />
<Route path='/Storeadmin/storeAdminForm' element={<StoreAdminForm />} />
<Route path='/StoreBalanceByCustomer' element={<StoreBalanceByCustomer />} />
<Route path='/StoreBalanceByUser' element={<StoreBalanceByUser />} />
<Route path='/StoreBankUserList' element={<StoreBankUserList />} />
<Route path='/StoreCartScreen/:id' element={<StoreCartScreen />} />
<Route path='/StoreCashUserList' element={<StoreCashUserList />} />
<Route path='/StoreTransferForm' element={<StoreTransferForm />} />
<Route path='/StoreSupplyForm' element={<StoreSupplyForm />} />
<Route path='/copy/stock/:id/copy' element={<StocksAddScreen />} />
<Route path='/copy/dailystock/:id/copy' element={<DailyStocksAddScreen />} />
<Route path='/create/otherExpense/excelform' element={< AddOtherExpenseFromExcelScreen />} />
<Route path='/create/staff/otherExpense/' element={< AddStaffOtherExpense />} />
      
      </Route>
      {/* Admin users */}
      <Route path='' element={<AdminRoute />}>

      <Route path='/create/otherExpense' element={<AddOtherExpenseScreen />} />
      
      <Route path='/admin/otherExpensecategory' element={<OtherExpenseCategory />} />
      <Route path='/admin/otherExpense/:id/edit' element={<OtherExpenseEditScreen />} />
      <Route path='/admin/otherExpenseinvoices' element={<OtherExpenseInvoices />} />
      <Route path='/admin/otherExpenseinvoicesummary' element={<OtherExpenseInvoiceSummary />} />
      <Route path='/admin/otherExpenselist' element={<OtherExpenseListScreen />} />
      <Route path='/admin/otherExpensesearchreplace' element={<OtherExpenseSearchReplaceScreen />} />
       <Route path='/update/otherExpense/excelform' element={<BulkEditOtherExpensesScreen />} />
       <Route path='/bulk/update/otherExpense' element={<BulkOtherExpenseBatchUpdateScreen />} />
      

        <Route path='admin/sale/:id/edit' element={<SalesEditScreen />} />
        <Route path='/admin/transfer/:id/edit' element={<TransferEditScreen />} />
        <Route path='/admin/transfer/:id/copy' element={<TransferAddScreen />} />
        <Route path='/openingStock/:id/edit' element={<OpeningStocksEditScreen />} />
        <Route path='admin/stock/:id/edit' element={<StocksEditScreen />} />
        <Route path='admin/dailyStock/:id/edit' element={<DailyStocksEditScreen />} />
        <Route path='/admincopy/sale/:id/copy' element={<SalesAddScreen />} />
        <Route path='/admincopy/stock/:id/copy' element={<StocksAddScreen />} />
        <Route path='/admincopy/dailystock/:id/copy' element={<DailyStocksAddScreen />} />
        <Route path='/admin/expensesearchreplace' element={<ExpenseSearchReplaceScreen />} />
        <Route path='/admin/stocknotesearchreplace' element={<StockNoteSearchReplaceScreen />} />
        <Route path='/admin/stocksearchreplace' element={<StocksSearchReplaceScreen />} />
        <Route path='/admin/dailystocknotesearchreplace' element={<DailyStockNoteSearchReplaceScreen />} />
        <Route path='/admin/dailystocksearchreplace' element={<DailyStocksSearchReplaceScreen />} />
         <Route path='/admin/openingstocksearchReplace' element={<OpeningStockSearchReplaceScreen />} />
         <Route path='/storeAdmin/openingstocksearchReplace' element={<OpeningStoreStockSearchReplaceScreen />} />
        <Route path='/admin/transfersearchreplace' element={<TransfersSearchReplaceScreen />} />
        <Route path='/admin/supplysearchreplace' element={<SupplysSearchReplaceScreen />} />
        <Route path='/admin/salesearchreplace' element={<SalesSearchReplaceScreen />} />
        <Route path='/admin/salesearchdelete' element={<SalesSearchDeleteScreen />} />
        <Route path='/admin/stocksearchdelete' element={<StocksSearchDeleteScreen />} />
        <Route path='/admin/transfersearchdelete' element={<TransfersSearchDeleteScreen />} />
        <Route path='/admin/daiystocksearchdelete' element={<DailyStocksSearchDeleteScreen />} />

        <Route path='/admin/salenotesearchreplace' element={<SaleNoteSearchReplaceScreen />} />
        <Route path='/balance' element={< Balance />} />
        <Route path='/StoreBalance' element={<StoreBalance />} />
        <Route path='/consolidatedbalance' element={<ConsolidatedBalance />} />
        <Route path='/consolidatedworkingcapital' element={<ConsolidatedWorkingCapital />} />
       <Route path='/balancebyuser' element={< BalanceByUser />} />
      <Route path='/balancebycustomer' element={< BalanceByCustomer />} />
        <Route path='/admin/orderlist' element={<OrderListScreen />} />
        <Route path='/admin/salelist' element={<SaleListScreen />} />
        <Route path='/admin/stocklist' element={<StockListScreen />} />
        <Route path='/admin/dailystocklist' element={<DailyStockListScreen />} />
        <Route path='/admin/openingstocklist' element={<OpeningStockListScreen />} />
        <Route path='/admin/transferlist' element={<TransferListScreen />} />
        <Route path='/admin/productlist' element={<ProductListScreen />} />
        <Route path='/admin/expenselist' element={<ExpenseListScreen />} />
        <Route path='/admin/depositlist' element={<DepositListScreen />} />
        <Route path='/admin/notelist' element={<NoteListScreen />} />
        <Route path='/netcash' element={< NetCash />} />
        <Route path='/admin/insurance/:id/edit' element={<InsurancesEditScreen />} />
        <Route path='/admin/insurancelist' element={<InsuranceListScreen />} />

        <Route path='/admin/bill/:id/edit' element={<BillsEditScreen />} />
        <Route path='/admin/billlist' element={<BillListScreen />} />

        <Route path='/adminform' element={<AdminForm />} />
        <Route path='/admin/startstockscreen' element={<StartStockScreen />} />
        <Route path='/admin/expensecategory' element={<ExpenseCategory />} />
        <Route path='/admin/incomecategory' element={<IncomeCategory />} />
        <Route path='/admin/baglist' element={<BagListScreen />} />
        <Route path='/admin/workingcapital' element={<WorkingCapital />} />
        <Route
          path='/productlist/:pageNumber'
          element={<ProductListScreen />}  
        />
        <Route
          path='/admin/salelist/:pageNumber'
          element={<SaleListScreen />}
        />
        <Route
          path='/staffhouselist/:pageNumber'
          element={<StaffHouseList />}
        />
        <Route
          path='/admin/transferlist/:pageNumber'
          element={<TransferListScreen />}
        />
        <Route
          path='/admin/supplylist/:pageNumber'
          element={<SupplyListScreen />}
        />
        <Route
          path='/admin/purchaselist/:pageNumber'
          element={< PurchaseListScreen/>}
        />
        <Route
          path='/admin/purchaselist'
          element={< PurchaseListScreen/>}
        />
        <Route path='/admin/supplysummary' element={<SupplySummary />} />
        <Route path='/admin/stockbulkeditscreen' element={<StockBulkEditScreen />} />
        <Route path='/admin/customerimportscreen' element={<CustomerImportScreen />} />
        <Route path='/admin/customereditimportscreen' element={<CustomerEditImportScreen />} />
        <Route path='/admin/supplyinvoicesummary' element={<SupplyInvoiceSummary />} />
        <Route path='/admin/expenseinvoicesummary' element={<ExpenseInvoiceSummary />} />
        <Route path='/admin/expenseinvoices' element={<ExpenseInvoices />} />
        <Route path='/admin/incomeexpensecategories' element={<IncomeExpenseCategories />} />
        <Route
          path='/admin/stocklist/:pageNumber'
          element={<StockListScreen />}
        />
        <Route
          path='/admin/supplierbalance/'
          element={<SupplierBalanceScreen />}
        />
        <Route
          path='/admin/customerlist/:pageNumber'
          element={<CustomerListScreen />}
        />
        <Route
          path='/admin/supplierlist/:pageNumber'
          element={<SupplierListScreen />}
        />
         <Route path='/update/income/excelform' element={< BulkIncomeUpdateWithImageUploadScreen />} />
         <Route path='/update/product/excelform' element={< BulkProductUpdateWithImageUploadScreen />} />
         <Route path='/update/expense/excelform' element={< BulkEditExpensesScreen />} />
         <Route path='/bulk/update/expense' element={< BulkExpenseBatchUpdateScreen />} />
         

        <Route
          path='/admin/openingstocklist/:pageNumber'
          element={<OpeningStockListScreen />}
        />
        <Route
          path='/admin/expenselist/:pageNumber'
          element={<ExpenseListScreen />}
        />
        <Route
          path='/admin/depositlist/:pageNumber'
          element={<DepositListScreen />}
        />
        <Route
          path='/netcash/:pageNumber'
          element={<NetCash />}
        />
        <Route
          path='/admin/notelist/:pageNumber'
          element={<NoteListScreen />}
        />
        <Route
          path='/admin/houselist/:pageNumber'
          element={<HouseListScreen />}
        />
        <Route
          path='/admin/baglist/:pageNumber'
          element={<BagListScreen />}
        />
        <Route path='/admin/houselist' element={<HouseListScreen />} /> {/* New route for House List */}
        <Route path='/admin/userlist' element={<UserListScreen />} />
        <Route path='/admin/product/:id/edit' element={<ProductEditScreen />} />
        
        <Route path='/admin/expense/:id/edit' element={<ExpenseEditScreen />} />
        <Route path='/admin/customer/:id/edit' element={<CustomerEditScreen />} />
        
        <Route path='/admin/supplier/:id/edit' element={<SupplierEditScreen />} />
        <Route path='/admin/customerlist' element={<CustomerListScreen />} />
        
        <Route path='/admin/supplierlist' element={<SupplierListScreen />} />
        <Route path='/admin/supplylist' element={<SupplyListScreen />} />
        <Route path='/admin/adminuserprofile' element={<AdminProfileScreen />} />
        <Route path='/admin/adminuserscreen' element={<AdminUsersScreen />} />
        <Route path='/admin/user/:id/edit' element={<UserEditScreen />} />

        <Route path='/storeadmin/storeSalelist' element={<StoreSaleListScreen />} />
        <Route path='/Storeadmin/storeAdminForm' element={<StoreAdminForm />} />
        <Route path='/StoreAdmin/storeExpensesearchreplace' element={<StoreExpenseSearchReplaceScreen />} />
        <Route path='/StoreAdmin/storeStocknotesearchreplace' element={<StoreStockNoteSearchReplaceScreen />} />
        <Route path='/StoreAdmin/storeStocksearchreplace' element={<StoreStocksSearchReplaceScreen />} />
        <Route path='/StoreAdmin/dailystoreStocknotesearchreplace' element={<DailyStoreStockNoteSearchReplaceScreen />} />
        <Route path='/StoreAdmin/dailystoreStocksearchreplace' element={<DailyStoreStocksSearchReplaceScreen />} />
        <Route path='/StoreAdmin/storeTransfersearchreplace' element={<StoreTransfersSearchReplaceScreen />} />
        <Route path='/StoreAdmin/storeSupplysearchreplace' element={<StoreSupplysSearchReplaceScreen />} />
        <Route path='/StoreAdmin/storeSalesearchreplace' element={<StoreSalesSearchReplaceScreen />} />
        <Route path='/StoreAdmin/storeSalelist' element={<StoreSaleListScreen />} />
        <Route path='/StoreAdmin/storeStocklist' element={<StoreStockListScreen />} />
        <Route path='/StoreAdmin/dailystoreStocklist' element={<DailyStoreStockListScreen />} />
        <Route path='/StoreAdmin/storeTransferlist' element={<StoreTransferListScreen />} />
        
        <Route path='/StoreAdmin/storedepositlist' element={<StoreDepositListScreen />} />
        <Route path='/StoreAdmin/startstoreStockscreen' element={<StartStoreStockScreen />} />
        <Route path='/StoreAdmin/storeExpensecategory' element={<StoreExpenseCategory />} />
        <Route path='/StoreAdmin/storeIncomecategory' element={<StoreIncomeCategory />} />
        <Route path='/StoreAdmin/storeworkingcapital' element={<StoreWorkingCapital />} />
        <Route path='/StoreAdmin/storeSalelist/:pageNumber' element={<StoreSaleListScreen />} />
         <Route path='/StoreAdmin/storeTransferlist/:pageNumber' element={<StoreTransferListScreen />} />
        <Route path='/StoreAdmin/storeSupplylist/:pageNumber' element={<StoreSupplyListScreen />} />
        <Route path='/StoreAdmin/storeSupplysummary' element={<StoreSupplySummary />} />
        <Route path='/StoreAdmin/storeStockbulkeditscreen' element={<StoreStockBulkEditScreen />} />
        <Route path='/StoreAdmin/storeSupplyinvoicesummary' element={<StoreSupplyInvoiceSummary />} />
         <Route path='/StoreAdmin/storeExpenseinvoicesummary' element={<StoreExpenseInvoiceSummary />} />
         <Route path='/StoreAdmin/storeExpenseinvoices' element={<StoreExpenseInvoices />} />
        <Route path='/StoreAdmin/storeStocklist/:pageNumber' element={<StoreStockListScreen />} />
        <Route path='/update/storeIncome/excelform' element={<BulkStoreIncomeUpdateWithImageUploadScreen />} />
        <Route path='/update/storeExpense/excelform' element={<BulkEditStoreExpensesScreen />} />
        <Route path='/bulk/update/storeExpense' element={<BulkStoreTransferBatchUpdateScreen />} />
        <Route path='/StoreAdmin/openingstoreStocklist' element={<OpeningStoreStockListScreen />} />
        <Route path='/StoreAdmin/storeExpenselist/:pageNumber' element={<StoreExpenseListScreen />} />
        <Route path='/StoreAdmin/storeExpenselist' element={<StoreExpenseListScreen />} />
        <Route path='/StoreAdmin/depositlist/:pageNumber' element={<StoreDepositListScreen />} />
        <Route path='/storeAdmin/storeExpense/:id/edit' element={<StoreExpenseEditScreen />} />
        <Route path='/StoreAdmin/storeSupplylist' element={<StoreSupplyListScreen />} />
        <Route path='/openingStoreStock/:id/edit' element={<OpeningStoreStockEditScreen />} />
        <Route path='/storeAdmin/AddStoreDepositScreen' element={<AddStoreDepositScreen />} />
        <Route path='/storeAdmin/AddStoreExpenseFromExcelScreen' element={<AddStoreExpenseFromExcelScreen />} />
        
        <Route path='/storeAdmin/AddStoreIncomeFromExcelScreen' element={<AddStoreIncomeFromExcelScreen />} />
        <Route path='/storeIncome/:id' element={<AddStoreIncomeScreen />} />
        <Route path='/storeAdmin/Balance' element={<Balance />} />
        <Route path='/storeAdmin/BalanceByCustomer' element={<BalanceByCustomer />} />
        <Route path='/storeAdmin/BalanceByCustomerStaff' element={<BalanceByCustomerStaff />} />
        <Route path='/storeAdmin/BalanceByUser' element={<BalanceByUser />} />
        <Route path='/storeAdmin/BalanceByUserStaff' element={<BalanceByUserStaff />} />
        <Route path='/storeAdmin/BalanceStaffScreen' element={<BalanceStaffScreen />} />
        <Route path='/storeAdmin/DailyStoreStockAnalysis' element={<DailyStoreStockAnalysis />} />
        <Route path='/storeAdmin/DailyStoreStockReport' element={<DailyStoreStockReport />} />
        <Route path='/storeAdmin/DailyStoreStockUniqueDates' element={<DailyStoreStockUniqueDates />} />
        <Route path='/storeAdmin/NetStoreCash' element={<NetStoreCash />} />
        <Route path='/storeIncome/:id/edit' element={<NetStoreCashEdit />} />
        <Route path='/storeAdmin/ReportStoreStockScreen' element={<ReportStoreStockScreen />} />
        <Route path='/storeAdmin/StockDateStoreExpenses' element={<StockDateStoreExpenses />} />
        <Route path='/storeAdmin/StoreAllTotal' element={<StoreAllTotal />} />
        <Route path='/storeAdmin/StoreDepositEditScreen' element={<StoreDepositEditScreen />} />
        <Route path='/storeAdmin/StoreDepositStaffEditScreen' element={<StoreDepositStaffEditScreen />} />
        <Route path='/storeAdmin/StoreExpenseCategories' element={<StoreExpenseCategories />} />
        <Route path='/storeAdmin/StoreExpenseStaffEditScreen' element={<StoreExpenseStaffEditScreen />} />
        <Route path='/storeAdmin/StoreStockAnalysis' element={<StoreStockAnalysis />} />
        <Route path='/storeAdmin/StoreStockReport' element={<StoreStockReport />} />
        <Route path='/storeAdmin/StoreStockUniqueDates' element={<StoreStockUniqueDates />} />
        
        <Route path='/StoreExpenseCategory' element={<StoreExpenseCategory />} />
       
        <Route path='/StoreExpenseInvoices' element={<StoreExpenseInvoices />} />
        <Route path='/StoreExpenseInvoiceSummary' element={<StoreExpenseInvoiceSummary />} />
        <Route path='/StoreIncomeCategory' element={<StoreIncomeCategory />} />
        <Route path='/StoreIncomeExpenseCategories' element={<StoreIncomeExpenseCategories />} />
        <Route path='/storeSale/:id/edit' element={<StoreSalesEditScreen />} />
        <Route path='/storeSale/:id/copy' element={<StoreSalesAddScreen />} />
        <Route path='/storeStock/:id/edit' element={<StoreStockEditScreen />} />
        <Route path='/storeSupply/:id/edit' element={<StoreSupplyEditScreen />} />
        <Route path='/storeTransfer/:id/edit' element={<StoreTransferEditScreen />} />
        <Route path='/storeTransfer/:id/copy' element={<StoreTransferAddScreen />} />
        <Route path='/openingStoreStock/:id/edit' element={<OpeningStoreStockEditScreen />} />
        <Route path='/StoreExpenseSearchReplaceScreen' element={<StoreExpenseSearchReplaceScreen />} />

        
      </Route>
    </Route>
  ),
  

);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PayPalScriptProvider deferLoading={true}>
          <RouterProvider router={router} />
        </PayPalScriptProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
